import { openModal } from "./modal";
import { pieceIcon, PIECE_NAMES_FR } from "./pieceIcons";
import type { PromotionPiece } from "../game/engine";
import type { Color } from "../game/types";

const CHOICES: PromotionPiece[] = ["q", "r", "b", "n"];

export function showPromotionModal(color: Color): Promise<PromotionPiece> {
  return new Promise((resolve) => {
    const content = document.createElement("div");
    content.innerHTML = `<h2>Promotion du pion</h2><p class="subtitle">Choisissez la piece</p>`;
    const choices = document.createElement("div");
    choices.className = "promotion-choices";
    content.appendChild(choices);

    let resolved = false;
    const { close } = openModal(content, { dismissible: false });

    for (const type of CHOICES) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.title = PIECE_NAMES_FR[type];
      btn.style.fontSize = "2.2rem";
      btn.textContent = pieceIcon(color, type);
      btn.addEventListener("click", () => {
        if (resolved) return;
        resolved = true;
        close();
        resolve(type);
      });
      choices.appendChild(btn);
    }
  });
}
